import { render } from "./Button.vue?vue&type=template&id=25148d4e&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=25148d4e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-25148d4e"

export default script